import { useMemo } from 'react'

import { servicesAdapter } from '@/features/product-services'

import { useGetProductServicesQuery } from '@/entities/product'

import { useProductSsrData } from '../context/product-ssr-data-context'

import { useProductDescriptionData } from './use-product-description-data'
import { useProductPaymentsData } from './use-product-payments-data'

export function useProductPageData(productId: number) {
	const ssr = useProductSsrData()
	const hasSsrServices = ssr?.services != null

	const { data: payments, isLoading: isPayLoading } = useProductPaymentsData(productId)
	const { data: description, isLoading: isDescriptionLoading } = useProductDescriptionData(productId)
	const { data: servicesData, isLoading: isServicesLoading } = useGetProductServicesQuery(productId, {
		skip: hasSsrServices
	})
	const services = hasSsrServices ? ssr.services : servicesData

	const adaptedService = useMemo(() => (services ? servicesAdapter(services) : []), [services])

	return useMemo(
		() => ({
			description,
			services: adaptedService,
			payments,
			isLoading: isPayLoading || isDescriptionLoading || isServicesLoading
		}),
		[description, services, payments]
	)
}
